import { useState } from 'react'
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description'
import AddIcon from '@mui/icons-material/Add'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useMedicalCertificate } from './MedicalCertificateContext'

/**
 * Header "+" entry point for medical documents (shown on both the calendar and appointments tabs).
 * Opens a small menu with Create / View existing; both start with a patient picker since there is no
 * appointment context here. Rendered only for doctors/therapists when the launcher provider exists.
 */
export default function MedicalCertificateHeaderButton({ compact = false }) {
  const medicalCertificate = useMedicalCertificate()
  const [anchorEl, setAnchorEl] = useState(null)
  const roles = getAllRolesInBoolean()

  if (!medicalCertificate || !(roles.isDoctor || roles.isTherapist)) {
    return null
  }

  const handleOpenMenu = (e) => setAnchorEl(e.currentTarget)
  const handleCloseMenu = () => setAnchorEl(null)

  const handleCreate = () => {
    handleCloseMenu()
    medicalCertificate.openCreate(null)
  }
  const handleView = () => {
    handleCloseMenu()
    medicalCertificate.openView(null)
  }

  return (
    <>
      <Tooltip title="Medical Certificate" arrow>
        <Button
          onClick={handleOpenMenu}
          startIcon={<DescriptionIcon sx={{ fontSize: 20 }} />}
          sx={{
            textTransform: 'none',
            color: 'rgba(67, 56, 202, 0.95)',
            backgroundColor: 'rgba(67, 56, 202, 0.08)',
            border: '1px solid rgba(67, 56, 202, 0.2)',
            borderRadius: '10px',
            padding: compact ? '8px' : '6px 12px',
            minWidth: compact ? 0 : undefined,
            whiteSpace: 'nowrap',
            '& .MuiButton-startIcon': { marginRight: compact ? 0 : '6px' },
            '&:hover': {
              backgroundColor: 'rgba(67, 56, 202, 0.14)',
              borderColor: 'rgba(67, 56, 202, 0.4)',
            },
          }}
        >
          {!compact && 'Medical Certificate'}
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { borderRadius: 2, minWidth: 220 } }}
      >
        <MenuItem onClick={handleCreate}>
          <ListItemIcon>
            <AddIcon sx={{ fontSize: 20, color: '#ec4899' }} />
          </ListItemIcon>
          <ListItemText primary="Create certificate" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </MenuItem>
        <MenuItem onClick={handleView}>
          <ListItemIcon>
            <VisibilityIcon sx={{ fontSize: 20, color: '#0ea5e9' }} />
          </ListItemIcon>
          <ListItemText primary="View existing certificates" primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
        </MenuItem>
      </Menu>
    </>
  )
}
